var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company_heading row__spacebetween row__spacebetween--bottom mb-25"},[_c('img',{attrs:{"src":_vm.oneCompany.logo}}),_c('BackLinks')],1)}
var staticRenderFns = []

export { render, staticRenderFns }